import { UnfoldMoreOutlined } from '@mui/icons-material';
import { Avatar, Box, Popover, Typography, styled } from '@mui/material';
import { Column, Row } from 'components/Layout';
import OrganisationSwitcherModal from './OrganisationSwitcherModal';
import { useState } from 'react';
import { AdminUserRealm } from 'further-types/admin-user';
import { useLayoutContext } from 'contexts/LayoutContext';

const Logo = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(8),
  height: theme.spacing(8),
}));

const Switcher = styled(Box)(({ theme }) => ({
  cursor: 'pointer',

  '&:hover .MuiSvgIcon-root:not(.MuiAvatar-fallback)': {
    color: theme.palette.grey[900],
  },
}));

const VehicleName = styled(Typography)({
  lineHeight: '14px',
});

type Props = {
  currentRealm?: AdminUserRealm;
  currentOrganisation?: {
    firmName: string;
    investmentFirmLogo: string;
  };
  otherOrganisations: Array<{
    auth0OrgId?: string;
    firmName?: string;
    firmLogo?: string;
    realm?: AdminUserRealm;
  }>;
};

const OrganisationSwitcher: React.FC<Props> = ({
  currentOrganisation,
  otherOrganisations,
  currentRealm,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const { vehicle } = useLayoutContext();

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!currentOrganisation) return null;

  const isOpen = Boolean(anchorEl);

  return (
    <>
      <Switcher onClick={handleClick}>
        <Row centered spacing="xs" justify="space-between">
          <Row centered spacing="xs">
            <Logo
              src={currentOrganisation.investmentFirmLogo}
              variant="rounded"
            />
            <Column spacing="xxs">
              <Typography variant="h6" lineHeight="140%">
                {currentOrganisation.firmName}
              </Typography>
              <VehicleName variant="caption">
                {vehicle?.vehicleName ?? ''}
              </VehicleName>
            </Column>
          </Row>
          <UnfoldMoreOutlined />
        </Row>
      </Switcher>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <OrganisationSwitcherModal
          currentOrganisation={currentOrganisation}
          otherOrganisations={otherOrganisations}
          currentRealm={currentRealm}
          onVehicleChange={handleClose}
        />
      </Popover>
    </>
  );
};

export default OrganisationSwitcher;
